import {
  MILEAGE_LOGS_LIST,
  MILEAGE_LOG_GET,
  MILEAGE_LOG_CREATE,
  MILEAGE_LOG_UPDATE,
  MILEAGE_LOG_DELETE,
  MILEAGE_INVALIDATE,
} from 'store/actions/mileageActions';

const initialState = {
  logs:          { data: [], loading: false, error: null },
  log:           { data: null, loading: false, error: null },
  invalidatedAt: null,
};

const getData = (action) => action.response?.data ?? action.data ?? null;

export const mileage = (state = initialState, action = null) => {
  if (!action) return state;

  switch (action.type) {

    // ── List logs ──────────────────────────────────────────────────────────
    case MILEAGE_LOGS_LIST:
      return { ...state, logs: { ...state.logs, loading: true, error: null } };
    case `${MILEAGE_LOGS_LIST}_SUCCESS`:
      return { ...state, logs: { data: getData(action) || [], loading: false, error: null } };
    case `${MILEAGE_LOGS_LIST}_ERROR`:
      return { ...state, logs: { data: [], loading: false, error: action.error } };

    // ── Get single log ─────────────────────────────────────────────────────
    case MILEAGE_LOG_GET:
      return { ...state, log: { data: null, loading: true, error: null } };
    case `${MILEAGE_LOG_GET}_SUCCESS`:
      return { ...state, log: { data: getData(action), loading: false, error: null } };
    case `${MILEAGE_LOG_GET}_ERROR`:
      return { ...state, log: { data: null, loading: false, error: action.error } };

    // ── Create log ─────────────────────────────────────────────────────────
    case MILEAGE_LOG_CREATE:
      return { ...state, log: { data: null, loading: true, error: null } };
    case `${MILEAGE_LOG_CREATE}_SUCCESS`: {
      const newLog = getData(action);
      return {
        ...state,
        log:  { data: newLog, loading: false, error: null },
        logs: {
          ...state.logs,
          data: [newLog, ...(state.logs.data || [])],
        },
      };
    }
    case `${MILEAGE_LOG_CREATE}_ERROR`:
      return { ...state, log: { data: null, loading: false, error: action.error } };

    // ── Update log ─────────────────────────────────────────────────────────
    case MILEAGE_LOG_UPDATE:
      return { ...state, log: { ...state.log, loading: true, error: null } };
    case `${MILEAGE_LOG_UPDATE}_SUCCESS`: {
      const updated = getData(action);
      return {
        ...state,
        log:  { data: updated, loading: false, error: null },
        logs: {
          ...state.logs,
          data: (state.logs.data || []).map((l) =>
            l.id === updated?.id ? updated : l
          ),
        },
      };
    }
    case `${MILEAGE_LOG_UPDATE}_ERROR`:
      return { ...state, log: { ...state.log, loading: false, error: action.error } };

    // ── Delete log ─────────────────────────────────────────────────────────
    case `${MILEAGE_LOG_DELETE}_SUCCESS`: {
      const deletedId = action.meta?.requestAction?.id;
      return {
        ...state,
        logs: {
          ...state.logs,
          data: (state.logs.data || []).filter((l) => l.id !== deletedId),
        },
      };
    }

    // ── Invalidate cache ───────────────────────────────────────────────────
    case MILEAGE_INVALIDATE:
      return { ...state, invalidatedAt: Date.now() };

    default:
      return state;
  }
};
